require([
    'ch_utils',
    'ch_stripe',
    'ch_numeric_stepper',
    'ch_form_url_sync',
    'jquery',
    'semantic',
    'services',
    'ch_header',
    'ch_form_validation',
    'ch_semantic_responsive',
    'ch_welcome_overlay',
    'stripe',
], function (utils, CourseHorseStripe, numericStepper, formUrlSync) {
    const maxMessageCharacterCount = 500;
    const deliveryTypes = {
        EMAIL: 'Email',
        PRINT: 'Print',
    };
    const formSelector = "#form_GiftCard";

    // Get stripe going
    const chStripe = new CourseHorseStripe.gateway({
        apiKey: CH.stripeApiKey,
        initialAmount: CH.checkout.paymentIntentInitialAmount,
        checkoutType: 'gift-card',
        checkoutFormId: formSelector,
        returnUrl: CH.checkout.completeUrl,
        appearance: {
            variables: {
                borderRadius: "0.75rem",
            },
        },
    });
    chStripe.addExpressElement('#express-checkout-element');

    // Elements for template selector
    const templateSelector = document.querySelector('.js-gift-card-selector');
    const mainImage = document.querySelector('#selected-gift-card img');
    const templateField = document.querySelector('input[name=template_id]');
    
    // Elements for amount chooser
    const setAmountRadioGroup = document.querySelector('#set-amount-radio-group');
    const customAmountInput = document.querySelector("input[name=custom_amount]");
    const customAmountRadio = document.querySelector("input[name=set_amount][value=CUSTOM]");
    const amountInput = document.querySelector('input[name=amount]');

    // Elements for Seats quantity
    const seatsInputs = document.querySelector('input[name=seats]');

    // Elements for message
    const characterCounter = document.querySelector("#characters-remaining");
    const messageInput = document.querySelector('textarea[name=description]')

    // Elements for delivery type selector
    const deliveryTypeRadioGroup = document.querySelector('#delivery-type-radio-group');
    const recipientEmailInput = document.querySelector('input[name=email]');

    const deliveryDateInput = document.querySelector('input[name=delivery_date]');

    // Elements for displaying dynamic data
    const totalDueDisplay = document.querySelector('.js-gift-card-deal-total');
    const totalValueDisplay = document.querySelector('.js-gift-card-value-total');
    const willEarnPointsAmountDisplay = document.querySelector('.js-will-earn-points-amount');
    const willEarnPointsDollarValueDisplay = document.querySelector('.js-will-earn-points-dollar-value');

    const initialAmount = amountInput.value;

    // Event listeners
    templateSelector.addEventListener('change', handleTemplateSelectorRadio)
    deliveryTypeRadioGroup.addEventListener('change', handleDeliveryTypeRadioChange)
    messageInput.addEventListener('input', handleMessageInput)
    if (setAmountRadioGroup) {
        customAmountInput.addEventListener('blur', handleCustomAmountBlur);
        customAmountInput.addEventListener('input', handleCustomAmountInput)
        setAmountRadioGroup.addEventListener('change', handleSetAmountRadio);
        setAmountRadioGroup.addEventListener('focusin', handleSetAmountRadio);
    }
    if (seatsInputs) {
        numericStepper.setup([seatsInputs]);
        seatsInputs.addEventListener('input', handleSeatsChange)
    }


    // Set up form URL Sync
    // Form changes will be reflected in an encoded URL param called `f`
    // Conversely, The form will be updated based on `f` when the page loads
    formUrlSync.init(formSelector, {
        // Array of field names to exclude from both save and restore
        excludeFromSync: ['name', 'email'],

        // `afterRestore` runs after FormURLSync has restored form fields from URL
        afterRestore: function (data) {
            // Make sure template selector UI matches hidden input
            const templateSelectorRadioInput = templateSelector.querySelector(`input[data-id="${data.template_id}"]`)
            templateSelectorRadioInput.checked = true
            setMainImage(templateSelectorRadioInput)

            // dispatch an event for seatsInput so that the +/- button states are set correctly
            if (seatsInputs) {
                seatsInputs.dispatchEvent(new Event('input', { bubbles: true }));
            }

            // Hide the recipient email and delivery date if the type is "PRINT". Show otherwise
            toggleFieldsForDeliveryType(data.type)

            // update display data and update Stripe
            handleAmountChange(data.amount)

            // If there is a custom amount set, make sure that is formatted correctly
            if (data.set_amount === "CUSTOM") {
                customAmountInput.dispatchEvent(new Event('change', { bubbles: true }));
                formatCustomAmountInput()
            }
        },
    })


    // Non-form Stuff
    // Init jQuery accordion
    $('.ui.accordion').accordion({ exclusive: false })
    

    function handleTemplateSelectorRadio(event) {
        // change main image
        setMainImage(event.target)

        // make sure form is all set
        templateField.value = event.target.dataset.id;

        // This is necessary for ch_form_url_sync since hidden inputs don't trigger form change events
        templateField.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    function handleDeliveryTypeRadioChange(event) {
        toggleFieldsForDeliveryType(event.target.value)
    }

    function handleMessageInput(event) {
        const charactersCount = event.target.value.length

        characterCounter.innerText = utils.charsRemainingMessage(charactersCount, maxMessageCharacterCount)
    }

    function handleCustomAmountInput(event) {
        const input = event.target;

        // Allow only digits and one decimal point
        input.value = input.value.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-period characters

        // Ensure only one decimal point is allowed
        if ((input.value.match(/\./g) || []).length > 1) {
            input.value = input.value.slice(0, -1); // Remove the extra decimal point
        }

        // Prevent leading zeroes like "0123"
        input.value = input.value.replace(/^0+(?=\d)/, '');

        handleAmountChange(input.value);
    }

    function handleCustomAmountBlur() {
        formatCustomAmountInput()
    }

    function handleSetAmountRadio(event) {
        if (event.target === customAmountInput || event.target == customAmountRadio) {
            customAmountInput.disabled = false;
            customAmountInput.setAttribute("aria-disabled", "false");
            customAmountInput.setAttribute("required", "");
            customAmountInput.focus();
        } else {
            customAmountInput.disabled = true;
            customAmountInput.setAttribute("aria-disabled", "true");
            customAmountInput.removeAttribute("required");
            customAmountInput.value = ""; // Clear custom input if another option is selected
            handleAmountChange(event.target.value);
        }
    }

    function handleSeatsChange(event) {
        const seats = event.target.value

        const newAmount = Number(initialAmount) * seats

        handleAmountChange(newAmount)

        // This is necessary for ch_form_url_sync since hidden inputs don't trigger form change events
        seatsInputs.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function handleAmountChange(value) {
        if (value !== "CUSTOM") {
            // This is a hidden input that needs to mirror either one of the radio options or the custom amount field
            amountInput.value = value
        }

        const amountOff = computeAmountOff(value)
        const totalDue = Number(value - amountOff);
        const points = computePoints(totalDue);

        const pointsWillEarn = points.pointsWillEarn
        const dollarValueOfPointsWillEarn = points.dollarValueOfPointsWillEarn

        willEarnPointsAmountDisplay.innerText = pointsWillEarn.toLocaleString()
        willEarnPointsDollarValueDisplay.innerText = utils.formatToUSD(dollarValueOfPointsWillEarn)

        if (chStripe && totalDue > 0) {
            chStripe.updateAmount(totalDue);
        }

        if (totalValueDisplay) {
            totalValueDisplay.innerText = utils.formatToUSD(value)
        }

        if (totalDueDisplay) {
            totalDueDisplay.innerText = utils.formatToUSD(totalDue)
        }
    }

    function toggleFieldsForDeliveryType(value) {
        recipientEmailInput.hidden = value !== deliveryTypes.EMAIL
        recipientEmailInput.disabled = value !== deliveryTypes.EMAIL

        // The input label
        recipientEmailInput.nextElementSibling.hidden = value !== deliveryTypes.EMAIL

        // The "floating label" container
        recipientEmailInput.parentElement.hidden = value !== deliveryTypes.EMAIL


        // Don't need to ask for delivery date when emailing to self
        deliveryDateInput.disabled = value === deliveryTypes.PRINT
        deliveryDateInput.closest('.gift-card-form__section').hidden = value === deliveryTypes.PRINT
    }

    function formatCustomAmountInput() {
        const input = customAmountInput

        const rawValue = input.value.replace(/(,|\$)/g, '')
        input.value = utils.formatToUSD(rawValue, true)
    }

    function setMainImage(templateSelectorRadioInput) {
        // change main image
        mainImage.setAttribute(
            'src',
            templateSelectorRadioInput.closest('label').querySelector('img').getAttribute('src'),
        )
    }

    function computeAmountOff(amount) {
        let amountOff = 0;

        if (CH.giftCardDealValue) {
            amountOff = (Number(CH.giftCardDealValue) * amount / 100);

            if (CH.giftCardDealMaxSavingsAmount) {
                amountOff = Math.min(amountOff, Number(CH.giftCardDealMaxSavingsAmount)).toFixed(2);
            }
        }

        return amountOff;
    }

    function computePoints(totalDue) {
        const pointsEarnedPerDollarSpent = CH.pointsEarnedPerDollarSpent;
        const pointsPricePerDollar = CH.pointsPricePerDollar;

        // Make sure these calculations match the calculations in PointsService.php
        const pointsWillEarn = utils.roundHalfDown(totalDue * pointsEarnedPerDollarSpent);
        const dollarValueOfPointsWillEarn = utils.roundHalfDown(pointsWillEarn / pointsPricePerDollar, 2);

        return {
            pointsWillEarn: pointsWillEarn,
            dollarValueOfPointsWillEarn: dollarValueOfPointsWillEarn,
        }
    }
});
